/**
 * Bewegungseingabe des Spielers (Masterprompt Abschnitte 28, 43).
 *
 * Wichtig zum Verstaendnis der Serverautoritaet:
 * Der Client schickt hier NICHT seine Position, sondern nur seine ABSICHT -
 * "ich moechte in diese Richtung laufen". Wohin er dadurch tatsaechlich kommt,
 * entscheidet allein der Server.
 *
 * Ein manipulierter Client kann sich damit nicht teleportieren. Er kann
 * hoechstens eine unsinnig grosse Richtung schicken - und die begrenzt der
 * Server auf Laenge 1, bevor er sie anwendet.
 */

import { schema, t, type SchemaType } from '@colyseus/schema';

export const MoveInput = schema(
  {
    /** Bewegungsrichtung entlang der Lane, -1 bis 1. */
    moveX: t.float32().default(0),
    /** Bewegungsrichtung quer zur Lane, -1 bis 1. */
    moveY: t.float32().default(0),
  },
  'MoveInput',
);
export type MoveInput = SchemaType<typeof MoveInput>;

/**
 * Dieselben Daten als einfache Form ohne Schema-Bindung.
 *
 * Der Client benutzt diese Variante: Er bekommt die Feldbeschreibung beim
 * Verbindungsaufbau automatisch vom Server und braucht die Schema-Klasse selbst
 * nicht - so gibt es garantiert nur EINE gueltige Definition, naemlich die des
 * Servers.
 */
export interface MoveInputData {
  moveX: number;
  moveY: number;
}
